import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { UnitType } from '../../../../../models/enums/unit-type.enum';
import { MeasurementService } from '../../../../../services/measurement.service';

@Component({
    selector: 'app-rec-gasket-stress',
    templateUrl: './rec-gasket-stress.component.html',
    styleUrls: ['./rec-gasket-stress.component.scss'],
    standalone: false
})
export class RecGasketStressComponent implements OnInit {
    @Input() cssClass;
    @Input() form: UntypedFormGroup;

    tooltip_position = 'above';

    constructor(private measSvc: MeasurementService) {}

    ngOnInit(): void {
        this.form
            .get('recGasketStress')
            .valueChanges.subscribe((value) =>
                this.form.get('recGasketStress').patchValue(this.measSvc.format(value, UnitType.DefaultStressUnit), { emitEvent: false })
            );
    }
}
